function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M157.043 93.3363C157.037 105.068 154.074 116.608 148.427 126.891C142.781 137.174 134.633 145.867 124.737 152.167L123.959 152.654C113.785 158.948 102.162 162.516 90.2087 163.014C78.2556 163.512 66.3756 160.924 55.7128 155.499C45.05 150.075 35.9638 141.995 29.3292 132.04C22.6947 122.085 18.7354 110.589 17.8326 98.6594C17.6994 96.9013 17.6328 95.127 17.6328 93.3363C17.6319 90.6621 17.7839 87.9899 18.0882 85.333C18.2702 83.7368 18.5057 82.1576 18.7946 80.5954C20.8331 69.65 25.4627 59.3517 32.2962 50.5619C39.1297 41.772 47.9684 34.746 58.0731 30.0714C68.1779 25.3969 79.2551 23.2096 90.3783 23.6926C101.501 24.1756 112.347 27.3148 122.009 32.8476C123.398 33.6446 124.753 34.4876 126.075 35.3767C126.36 35.5673 126.644 35.7613 126.925 35.9576C126.948 35.97 126.969 35.9844 126.988 36.0006C133.836 40.7452 139.782 46.6735 144.548 53.507C152.702 65.1863 157.064 79.0922 157.043 93.3363Z",
  fill: "url(#paint0_linear)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.157,
  d: "M2.53027 68.9396C2.53113 60.8548 4.44968 52.8855 8.12837 45.6861C11.8071 38.4868 17.141 32.2626 23.6921 27.5248C30.2432 22.7871 37.8247 19.6708 45.814 18.4319C53.8033 17.193 61.9726 17.8668 69.6509 20.398C77.3293 22.9292 84.2977 27.2456 89.984 32.9927C95.6703 38.7399 99.9124 45.7538 102.362 53.4587C104.811 61.1635 105.398 69.3394 104.074 77.3151C102.75 85.2908 99.5535 92.8387 94.7463 99.339L102.521 107.974L93.8878 115.746L86.786 107.858C79.3536 114.187 70.2646 118.254 60.5936 119.581C50.9226 120.908 41.0739 119.437 32.212 115.344C23.3501 111.25 15.8456 104.705 10.5857 96.4819C5.32583 88.2586 2.53052 78.7012 2.53027 68.9396H2.53027Z",
  fill: "#5C5C5C"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M145.424 143.82C145.389 146.75 144.209 149.55 142.137 151.622C140.065 153.693 137.265 154.873 134.335 154.909C132.799 154.907 131.279 154.598 129.864 154C128.449 153.401 127.168 152.525 126.097 151.423L90.6108 112.769C90.3104 112.483 90.0712 112.139 89.9078 111.757C89.7444 111.376 89.6602 110.966 89.6602 110.551C89.6602 110.136 89.7444 109.726 89.9078 109.344C90.0712 108.963 90.3104 108.619 90.6108 108.333L98.8487 100.095C99.1347 99.7947 99.4788 99.5556 99.86 99.3922C100.241 99.2288 100.652 99.1445 101.066 99.1445C101.481 99.1445 101.892 99.2288 102.273 99.3922C102.654 99.5556 102.998 99.7947 103.284 100.095L141.939 135.899C143.035 136.908 143.91 138.132 144.509 139.495C145.109 140.858 145.421 142.331 145.424 143.82Z",
  fill: "#B06328"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M141.622 135.582L139.721 133.998C141.343 135.961 142.238 138.422 142.256 140.968C142.256 145.087 137.186 146.671 134.335 143.82L101.067 110.551C100.637 110.101 100.121 109.742 99.5496 109.497C98.9777 109.252 98.362 109.125 97.7399 109.125C97.1177 109.125 96.502 109.252 95.9302 109.497C95.3583 109.742 94.8422 110.101 94.4132 110.551L91.2451 113.719L125.78 150.79C127.639 152.769 130.081 154.101 132.751 154.592C134.42 154.752 136.104 154.551 137.689 154.005C139.274 153.458 140.723 152.578 141.939 151.424C143.093 150.208 143.973 148.759 144.52 147.174C145.066 145.589 145.267 143.905 145.107 142.236C145.107 139.701 143.524 137.483 141.622 135.582Z",
  fill: "#A35425"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M108.988 113.72C108.541 113.767 108.092 113.655 107.72 113.403L99.7995 105.482C99.6493 105.339 99.5298 105.167 99.4481 104.976C99.3663 104.786 99.3242 104.581 99.3242 104.373C99.3242 104.166 99.3663 103.961 99.4481 103.77C99.5298 103.579 99.6493 103.407 99.7995 103.264C99.9425 103.114 100.115 102.995 100.305 102.913C100.496 102.831 100.701 102.789 100.908 102.789C101.116 102.789 101.321 102.831 101.512 102.913C101.702 102.995 101.874 103.114 102.017 103.264L109.938 111.185C110.088 111.328 110.208 111.5 110.29 111.691C110.371 111.881 110.413 112.087 110.413 112.294C110.413 112.501 110.371 112.707 110.29 112.897C110.208 113.088 110.088 113.26 109.938 113.403C109.938 113.72 109.305 113.72 108.988 113.72Z",
  fill: "#C97629"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M91.5455 107.303L97.8184 101.03L88.4091 91.621L82.1363 97.8939L91.5455 107.303Z",
  fill: "#F0F0F6"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M93.1467 102.63L94.7313 104.215L97.8994 101.046L88.394 91.541L82.0566 97.8783L86.8093 102.63C87.2066 102.182 87.6944 101.823 88.2406 101.577C88.7868 101.331 89.379 101.204 89.978 101.204C90.577 101.204 91.1692 101.331 91.7154 101.577C92.2616 101.823 92.7495 102.182 93.1467 102.63Z",
  fill: "#D8D8EB"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M6.01567 63.0248C6.0159 53.6251 8.80344 44.4366 14.0258 36.6211C19.2482 28.8057 26.6708 22.7143 35.355 19.1174C44.0393 15.5204 53.5951 14.5794 62.8142 16.4134C72.0332 18.2473 80.5014 22.7738 87.1479 29.4205C93.7944 36.0671 98.3207 44.5354 100.154 53.7545C101.988 62.9736 101.047 72.5294 97.4497 81.2136C93.8526 89.8978 87.761 97.3202 79.9455 102.542C72.1299 107.765 62.9413 110.552 53.5416 110.552C47.2979 110.56 41.114 109.337 35.344 106.951C29.574 104.566 24.3314 101.065 19.9165 96.6502C15.5016 92.2352 12.0013 86.9925 9.6159 81.2225C7.23055 75.4524 6.00711 69.2684 6.01567 63.0248Z",
  fill: "url(#paint1_linear)"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M53.542 101.045C74.5401 101.045 91.5625 84.0231 91.5625 63.0249C91.5625 42.0268 74.5401 25.0044 53.542 25.0044C32.5438 25.0044 15.5215 42.0268 15.5215 63.0249C15.5215 84.0231 32.5438 101.045 53.542 101.045Z",
  fill: "url(#paint2_linear)"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M34.8491 67.4606C35.6253 61.5989 38.3118 56.1563 42.4929 51.9752C46.674 47.7941 52.1165 45.1076 57.9783 44.3314H58.2954C63.6813 43.6983 63.9985 36.0935 58.9286 35.1432C55.7937 34.5634 52.5897 34.4565 49.4232 34.826C43.4391 35.7181 37.9 38.509 33.6222 42.7874C29.3444 47.0658 26.5543 52.6054 25.6631 58.5895C25.1281 61.7465 25.2348 64.979 25.9768 68.0938C26.9271 73.4797 34.5319 72.8465 35.1651 67.4606C34.8491 67.7778 34.8491 67.4606 34.8491 67.4606Z",
  fill: "white",
  fillOpacity: 0.05
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M18.6896 66.1928C18.719 56.1182 22.7342 46.4647 29.858 39.3408C36.9819 32.2169 46.6355 28.2018 56.7101 28.1723C66.0118 28.2733 74.9827 31.6375 82.0571 37.6778C78.489 33.6464 74.0965 30.4286 69.1769 28.2421C64.2573 26.0556 58.9254 24.9514 53.542 25.0043C43.4674 25.0337 33.8138 29.0488 26.6899 36.1727C19.5661 43.2966 15.5509 52.9501 15.5215 63.0248C15.5398 68.3971 16.6761 73.7069 18.858 78.6163C21.0399 83.5257 24.2196 87.9273 28.195 91.541C22.1545 84.4663 18.7903 75.495 18.6896 66.1928Z",
  fill: "#DBDBEB"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.813,
  d: "M90.2432 56.1598C93.5145 76.8138 78.9487 95.8738 58.2947 99.1451C48.593 100.682 38.335 97.4427 30.5582 92.9003C34.7133 96.3241 39.5555 98.8152 44.757 100.205C49.9585 101.595 55.3979 101.851 60.7071 100.957C70.653 99.3516 79.5597 93.8757 85.4814 85.7251C91.4031 77.5745 93.8587 67.4117 92.3118 57.4565C91.4532 52.1532 89.5003 47.0865 86.5773 42.5789C83.6543 38.0713 79.8251 34.2213 75.3334 31.2739C82.0566 37.2664 88.7066 46.4581 90.2432 56.1598Z",
  fill: "white"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M64.25 50.5L41.75 73",
  stroke: "white",
  strokeWidth: 12,
  strokeLinecap: "round"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M64.25 73L41.75 50.5",
  stroke: "white",
  strokeWidth: 12,
  strokeLinecap: "round"
});

var _ref16 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 17.6328,
  y1: 51.7953,
  x2: 140.196,
  y2: 138.5,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EDEDED"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#D0D0D0"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 101.068,
  y1: 110.552,
  x2: 14.9505,
  y2: 39.1679,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E8E8F0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F7F7FC"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear",
  x1: 22.6693,
  y1: 43.9386,
  x2: 91.5625,
  y2: 101.045,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C7C7C7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ACACAC"
})));

var SvgEmptySearchIcon = function SvgEmptySearchIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 181,
    height: 181,
    viewBox: "0 0 181 181",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEmptySearchIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/empty-search-icon.605c690b.svg";
export { ForwardRef as ReactComponent };